import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row no-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UploadFileInput = _resolveComponent("UploadFileInput")!
  const _component_UploadFileLog = _resolveComponent("UploadFileLog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_UploadFileInput),
    _createVNode(_component_UploadFileLog)
  ]))
}